import TransactionsGrid from "./TransactionsGrid";

/**
 * Renders the "Transactions" page
 * @returns {JSX.Element}
 * @constructor
 */
const TransactionsPage = () => {
    return (
        <div>
            <TransactionsGrid />
        </div>
    );
}

export default TransactionsPage;
